import { PAYMENT_ACCOUNT_TYPES } from 'Data/constants.js'

export function getPayorName(payor) {
  switch (payor.payment_account.account_type) {
    case PAYMENT_ACCOUNT_TYPES.Person:
      return payor.payment_account.person_payment_account.payer_person
        .first_name
    case PAYMENT_ACCOUNT_TYPES.Insurance:
      return payor.payment_account.insurance_payment_account.insurance_company
        .carrier_name
    default:
      return ''
  }
}
